import { ESection } from '@microfrontends/app-shell-v2'
import { TFireBase } from './type'

export const CAREER_CENTER_SHOW_MENU = 'CAREER_CENTER_SHOW_MENU'
export const MAKE_SEARCHABLE_CHOOSE = 'MAKE_SEARCHABLE_CHOOSE'

export const firebaseConfig: TFireBase = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? '',
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? '',
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL ?? '',
    refreshJWTUrl: `${process.env.NEXT_PUBLIC_VNW_JOBSEEKER_URL}/my-career-center/employer-message/?action=renewFirebaseJWT`
}

export const tabSection = {
    saved: ESection.SAVED_JOB,
    applied: ESection.APPLIED_JOB,
    viewed: ESection.VIEWED_JOB
}
